import DataTable from 'datatables.net-dt';
import 'datatables.net-plugins/sorting/date-de.js';

document.addEventListener('DOMContentLoaded', () => {
    const tableElement = document.getElementById('news-archive-table');
    if (!tableElement) {
        return;
    }

    const labels = tableElement.dataset;

    let table = new DataTable(tableElement, {
        columnDefs: [
            { type: 'de_date', targets: 0 },
        ],
        lengthMenu: [100, 200, 300],
        language: {
            search:            labels.i18nSearch,
            searchPlaceholder: labels.i18nSearchPlaceholder,
            lengthMenu:        labels.i18nLengthMenu,
            info:              labels.i18nInfo,
            infoEmpty:         labels.i18nInfoEmpty,
            infoFiltered:      labels.i18nInfoFiltered,
            infoPostFix:       "",
            zeroRecords:       labels.i18nZeroRecords,
            emptyTable:        labels.i18nEmptyTable,
        }
    });
});
